import classNames from "classnames/bind";
import { NextPrevButton } from "common/blocks/NextPrevButton";
import type { ReactNode } from "react";
import "swiper/css/navigation";
import styles from "./CarouselNavigation.module.scss";

const cx = classNames.bind(styles);

export interface CarouselNavigationProps {
    className?: string;
    children?: ReactNode | ReactNode[];
    title?: string;
    forId: string;
}

const CarouselNavigation = ({ className, title, children, forId }: CarouselNavigationProps) => {
    return (
        <nav className={cx("navigation", className)}>
            {children || (
                <div className={cx("controls")}>
                    {title && <h2 className={cx("title")}>{title}</h2>}
                    <NextPrevButton
                        id={"prevButton" + forId}
                        disabled={true}
                        direction="Left"
                        ariaLabelText="Carousel next"
                    />
                    <NextPrevButton
                        id={"nextButton" + forId}
                        direction="Right"
                        ariaLabelText="Carousel next"
                    />
                </div>
            )}
        </nav>
    );
};

export default CarouselNavigation;
